import { render, staticRenderFns } from "./MonetaryGiftForm.vue?vue&type=template&id=b837c6fe&scoped=true&"
import script from "./MonetaryGiftForm.vue?vue&type=script&lang=js&"
export * from "./MonetaryGiftForm.vue?vue&type=script&lang=js&"
import style0 from "./MonetaryGiftForm.vue?vue&type=style&index=0&id=b837c6fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b837c6fe",
  null
  
)

export default component.exports